import template from './edit-echelon.html'
import css from './edit-echelon.less'
import {EditEchelonController} from './edit-echelon.controller.js'

export const EditEchelonComponent = {
    template: template,
    controller: EditEchelonController,
    controllerAs: 'EditEchelonController',
    require: {
    parentSimulator: '^^simulatorComponent',
    parentMouvement: '^^mouvement'
  },
    bindings: {
      resource: '=',
      mouvement:'=',
      codemouvement:'=',
      doRemoveEchelon:'='
    }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/edit-echelon/edit-echelon.component.js